import { useEffect, useState } from "react";
import { PACE_BANDS, paceBand } from "@pagemates/shared";
import { reading } from "@pagemates/shared/copy";

const txt = reading.pacePicker;

/*
 * Usual pace as three presets with the number beside them. Both read one
 * value: a preset sets its number, and typing a number lights whichever
 * band it falls in (none when blank). The bands live in PACE_BANDS so
 * nothing else can disagree about where Steady starts.
 */
export function PacePicker({ id, value, onChange }: { id: string; value: number | null; onChange: (v: number | null) => void }) {
  const [text, setText] = useState(value === null ? "" : String(value));
  useEffect(() => { if (Number(text) !== value && !(text === "" && value === null)) setText(value === null ? "" : String(value)); }, [value]); // eslint-disable-line react-hooks/exhaustive-deps
  const band = paceBand(value);
  const type = (t: string) => {
    setText(t);
    const n = t.trim() === "" ? null : Math.round(Number(t));
    if (n === null) onChange(null);
    else if (Number.isFinite(n) && n >= 1 && n <= 500) onChange(n);
  };
  return (
    <div className="pace-pick">
      <div className="seg" role="radiogroup" aria-label={txt.usualPace}>
        {PACE_BANDS.map((b) => (
          <button key={b.key} type="button" role="radio" aria-checked={band === b.key} aria-pressed={band === b.key}
            onClick={() => { setText(String(b.preset)); onChange(b.preset); }}>{b.label}</button>
        ))}
      </div>
      <span className="row" style={{ gap: 8 }}>
        <input id={id} className="input num" type="number" inputMode="numeric" min={1} max={500} value={text} placeholder="—" aria-label={txt.pagesADay}
          onChange={(e) => type(e.target.value)} />
        <span className="muted small">pages a day</span>
      </span>
    </div>
  );
}
